import { render, staticRenderFns } from "./sw-country-choose.vue?vue&type=template&id=44068d1a&scoped=true&"
import script from "./sw-country-choose.vue?vue&type=script&lang=tsx&"
export * from "./sw-country-choose.vue?vue&type=script&lang=tsx&"
import style0 from "./sw-country-choose.vue?vue&type=style&index=0&id=44068d1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44068d1a",
  null
  
)

export default component.exports